import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { CheckSquare2, Ghost } from 'lucide-react'

// states_g
import { openRightbar, closeRightbar } from './../redux/rightbarSlice';
import { openosModal, closeosModal } from './../redux/osSlice';



import { icons } from "../utilities/icn";
import { images } from "../utilities/img";

// components
import BackDrop from './backdrop';
import OpenSchedule from './openschedule';








const RightBar = () => {


    const pathlocation = useLocation()
    const showrightbar = useSelector((state) => state.showrightbar.value)
    const user = useSelector((state) => state.user.value)
    const osmodal = useSelector((state) => state.osmodal.value)
    const dispatch = useDispatch()

    const [windowWidth, setWindowWidth] = useState(window.innerWidth)
    const [userSchedules, setuserschedules] = useState(null)


    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
            // console.log(window.innerWidth)
        };

        const handleScroll = () => {
            // console.log(window.scrollY)
            if(windowWidth < 850) {
                dispatch(closeRightbar())
            }
        }

        window.addEventListener('resize', handleResize);

        window.addEventListener('scroll', handleScroll);

        // Cleanup: Remove the event listener when the component is unmounted
        return () => {
            window.removeEventListener('resize', handleResize);
            window.removeEventListener('scroll', handleScroll)
        };
    }, []);

    useEffect(() => {
        if(windowWidth < 850) {
            dispatch(closeRightbar())
        } else if (windowWidth > 850) {
            dispatch(openRightbar())
        }
    }, [windowWidth])


    function formatTimestamp(timestamp, returnValue) {
        const date = new Date(timestamp);
      
        const now = new Date();
        const isToday =
          date.getDate() === now.getDate() &&
          date.getMonth() === now.getMonth() &&
          date.getFullYear() === now.getFullYear();
      
        const timeOptions = {
          hour: 'numeric',
          minute: '2-digit',
          hour12: true,
        };
        const timeStr = date.toLocaleTimeString(undefined, timeOptions); // e.g., 9:20 AM
      
        if(returnValue === 'time') {
            return timeStr
        } else if (returnValue === 'date') {
            if (isToday) {
              return `Today`;
            } else {
              const dateOptions = {
                month: 'short',
                day: 'numeric',
                year: 'numeric',
              };
              const dateStr = date.toLocaleDateString(undefined, dateOptions); // e.g., Mar 16, 2024
              return `${dateStr}`;
            }
        }
    }
    function getTimeLeftMessage(timestamp) {
        const now = Date.now();
        const diff = timestamp - now;
      
        if (diff <= 0) return "Time passed";
      
        const minutes = Math.floor(diff / (1000 * 60));
        const hours = Math.floor(minutes / 60);
        const remainingMinutes = minutes % 60;
      
        if (hours > 0 && remainingMinutes > 0) {
            return `${hours} hour`;
        } else if (hours > 0) {
            return `${hours} hour${hours > 1 ? "s" : ""}`;
        } else {
            return `${remainingMinutes} minute${remainingMinutes !== 1 ? "s" : ""}`;
        }
        // if (hours > 0 && remainingMinutes > 0) {
        //   return `${hours}h ${remainingMinutes}m left`;
        // } else if (hours > 0) {
        //   return `${hours} hour${hours > 1 ? "s" : ""} left`;
        // } else {
        //   return `${remainingMinutes} minute${remainingMinutes !== 1 ? "s" : ""} left`;
        // }
      }
      


    function isUpcomingToday(timestamp) {
        const now = new Date();
        const logDate = new Date(timestamp);
      
        // Check if it's today
        const isSameDay =
          logDate.getFullYear() === now.getFullYear() &&
          logDate.getMonth() === now.getMonth() &&
          logDate.getDate() === now.getDate();
      
        return isSameDay;
    }
    function isUpcomingFuture(timestamp) {
        const now = new Date();
        const logDate = new Date(timestamp);

        const isToday = logDate.toDateString() === now.toDateString(); // Checks if it's today

        const isFuture = timestamp > now.getTime(); // Checks if it's in the future

        return isFuture;
    }

    const handleUserschedules = () => {
        if(user) {
            if(user.schedules) {
                const upcomingToday = user.schedules.filter(schedule => isUpcomingToday(schedule.date))
                const upcomingFuture = user.schedules.filter(schedule => isUpcomingFuture(schedule.date))
                const upcomingSchedules = [...upcomingToday, ...upcomingFuture]
                // console.log(upcomingSchedules)
                setuserschedules(upcomingSchedules)
            }
        }
    }

    const handlepws = (value) => {
        const filter = value.filter(item => item.name === 'AI Post Workout Sessions' && (isUpcomingFuture(item.date) || isUpcomingToday(item.date)))
        return filter
    }

    useEffect(() => {

        handleUserschedules();
        const interval = setInterval(handleUserschedules, 5 * 60 * 1000); // Check every 5 min
        return () => clearInterval(interval);

    }, [])

    useEffect(() => {

        handleUserschedules();

    }, [user])

    

    const setAlltoNull = () => {
        dispatch(closeosModal())
    }



    return (  

        <div className="">

            {pathlocation.pathname !== '/auth' && pathlocation.pathname !== '/ring' && pathlocation.pathname !== '/account-data-deletion' && pathlocation.pathname !== '/privacy-policy' ? 
                <div className={`rightbar ${showrightbar ? 'active' : ''}`}>

                <div className="rightbar-inner">

                    {/* {windowWidth < 850 ? <div className="me-row flex justify-space-between align-center">
                        <h6 className='inter'>Me</h6>

                        <div className="me-close flex justify-center align-center cursor-pointer" onClick={() => dispatch(closeRightbar())}>
                            <img src={icons.header.close} alt="" />
                        </div>
                    </div> : null} */}

                    <div className="flex row justify-space-between align-center mgb-35 rightbar-ghost-head">
                        <div className="flex row gap-5 align-center rgh-item active cursor-pointer">
                            <Ghost size={15} color='rgba(30, 229, 233, 1)' />
                            <h2 className='hn_medium active'>GHOST MODE</h2>
                        </div>
                        <div className="flex row gap-5 align-center rgh-item cursor-pointer">
                            <h2 className='hn_medium d-white_c'>NORMAL</h2>
                        </div>
                        <div className="flex row gap-5 align-center rgh-item cursor-pointer">
                            <h2 className='hn_medium d-white_c'>LABS (beta)</h2>
                        </div>
                    </div>

                    <div className="mgb-35 rightbar-settings">
                        <div className="flex justify-space-between row align-center mgb-30">
                            <h2 className="hn_medium d-white_c">Risk Appetite:</h2>
                            <div className="flex row align-center gap-10">
                                <div className="flex row gap-7 align-center risk-select-item cursor-pointer">
                                    <div></div>
                                    <h2 className="hn_medium d-white_c">Normal</h2>
                                </div>
                                <div className="flex row gap-7 align-center risk-select-item cursor-pointer">
                                    <div></div>
                                    <h2 className="hn_medium d-white_c">Aggro</h2>
                                </div>
                            </div>
                        </div>

                        <div className="flex row gap-100 align-center mgb-30">
                            <h2 className="hn_medium d-white_c">Max Size:</h2>
                            <input type="number" className='hn_medium d-white_c' placeholder='0.0 SOL' />
                        </div>

                        <div className="flex row gap-100 align-center">
                            <h2 className="hn_medium d-white_c">Max Size:</h2>
                            <div className="flex row align-center gap-10 cursor-pointer">
                                <CheckSquare2 size={20} color='rgba(40, 56, 88, 1)' />
                                <h2 className="hn_medium d-white_c">Max Privacy</h2>
                            </div>
                        </div>
                    </div>

                    <div className="rightbar-btns flex column gap-15">
                        <div className="rightbar-btn buy flex justify-center cursor-pointer">
                            <p className="hn_medium text-transform-uppercase">buy</p>
                        </div>
                        <div className="rightbar-btn sell flex justify-center cursor-pointer">
                            <p className="hn_medium text-transform-uppercase">sell</p>
                        </div>
                        <div className="rightbar-btn create flex justify-center cursor-pointer">
                            <p className="hn_medium text-transform-uppercase">create</p>
                        </div>
                    </div>




                    


                </div>
                

            </div> : null}

        </div>

    );
}
 
export default RightBar;